// Normalize a user-entered website value into a canonical URL.
//
// Returns:
//   - ''   when the input is empty (treated as "no website provided")
//   - null when the input is non-empty but cannot be parsed as a URL
//   - the canonical https URL string otherwise (no trailing slash)
//
// Accepts shapes like:
//   `yourshop.com`, `www.yourshop.com`, `http://yourshop.com`,
//   `https://yourshop.com/path?ref=foo`
//
// The single-label hostname check rejects values like `foo` or `localhost`
// that the URL constructor would happily parse but are almost certainly typos
// for a public domain.
export const normalizeWebsite = (raw) => {
  if (raw === undefined || raw === null) return '';
  const trimmed = String(raw).trim();
  if (!trimmed) return '';

  const withScheme = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;

  let url;
  try {
    url = new URL(withScheme);
  } catch {
    return null;
  }

  if (!url.hostname || !url.hostname.includes('.')) {
    return null;
  }

  return url.toString().replace(/\/$/, '');
};
